<template>
    <div :class="{ 'show d-block': show }" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        v-if="settings.widget_speed_bump_type === 'button'"
                        class="btn-close"
                        type="button"
                        @click="closeModal"
                    ></button>
                </div>

                <div v-if="$te('speedBump.text')" class="modal-body">
                    <p class="mt-0">{{ $t('speedBump.text') }}</p>
                </div>
                <div v-if="settings.widget_speed_bump_type === 'button'" class="modal-footer">
                    <button class="btn btn-primary submitButton" type="button" @click="confirmModal()">
                        {{ $t('speedBump.buttonProceed.text') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="fade" :class="{ 'show d-block modal-backdrop': show }"></div>
</template>

<script>
export default {
    name: 'OfferRedirectModal',
    emits: ['closeModal', 'confirmModal'],
    props: {
        show: {
            default: false,
        },
        settings: {
            default: {},
        },
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        confirmModal() {
            this.$emit('confirmModal', false)
        },
    },
    watch: {
        show(value) {
            if (value === true && this.settings.widget_speed_bump_type === 'delay') {
                setTimeout(() => {
                    this.confirmModal()
                }, this.settings.widget_speed_bump_delay)
            }
        },
    },
}
</script>
